<script>
    export let project;
</script>

{#if project.images.modal}
    {#each project.images.modal as imagePath}
        <a href="{ imagePath }" class="glightbox" data-gallery="{ project.id }" data-type="image"></a>
    {/each}
{/if}